import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useGetClientNetworkQuery } from "../../services/rtkQueryServices/checkApiService";

const UTA_HIGHLIGHT_PATH = "/uta_faculty_awards";
const ORGANIZATION_PATH = "/societies";

export default function NetworkLandingRedirect() {
  const navigate = useNavigate();
  const { data, error, isLoading } = useGetClientNetworkQuery();

  useEffect(() => {
    if (isLoading) {
      return;
    }

    navigate(data?.is_uta_network ? UTA_HIGHLIGHT_PATH : ORGANIZATION_PATH, {
      replace: true,
    });
  }, [data, error, isLoading, navigate]);

  return null;
}